import axios from 'axios';

export function setupApiClient() {

    const api = axios.create({});

    return api;
}
